var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 7,
    r: 5,
    fill: "#181A1B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9986 22H4.79209C3.80194 22 3 21.1411 3 20.0844C3 18.1318 3.60009 16.1359 5.10032 15.0329C6.99879 13.6425 9.75102 13.4757 11.9986 13.5066C14.249 13.4726 17.0012 13.6425 18.8997 15.0329C20.3999 16.1328 21 18.1287 21 20.0844C21 21.1411 20.1981 22 19.2079 22H12.0014H11.9986Z",
    fill: "#181A1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.1f2aa06d2a7978306d9b1641671076de.svg";
export { ForwardRef as ReactComponent };